export var createMuiSnackbarContentOverrides = function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, palette = _a.palette, spacing = _a.spacing;
    return ({
        root: (_b = {
                color: undefined,
                padding: spacing(2),
                backgroundColor: palette.background.overlays,
                boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.35)",
                alignItems: "flex-start"
            },
            _b[breakpoints.up("sm")] = {
                minWidth: undefined,
            },
            _b),
        message: {
            minHeight: 40,
            display: "flex",
            alignItems: "center",
            padding: spacing(0, 2),
        },
        action: {
            paddingLeft: spacing(4),
            marginRight: undefined,
        },
    });
};
//# sourceMappingURL=MuiSnackbarContent.js.map